import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { AppConfig } from 'src/app/app.config';

export class TenderingAsListItem {
  Id: string;
  Iwmid: string;
  Identifier: string;
  Name: string;
}

@Injectable({
  providedIn: 'root'
})
export class AddItemsToTenderingService {

  constructor(private http: HttpClient,
    private config: AppConfig) { }

  public getOwnTenderingsWithNoSentBids(): Observable<Array<TenderingAsListItem>> {
    const url = `${this.config.backendIwmUri}TenderingApi/Tenderings/Default.GetOwnTenderingsWithNoSentBids?$filter=Archived eq false 
      and ((Identifier eq '' or Identifier eq null) and (Name eq '' or Name eq null)) ne true &$select=Id, IwmId, Identifier, Name`;

    return this.http.get<any>(url)
      .pipe(
        map(r => r.value as Array<TenderingAsListItem>));
  }


  public copyFileAttachmentsFromTaskToTendering(targetTenderingId: string,
    sourceTaskId: string): Observable<null> {
    const body: any = {
      DestinationTenderingId: targetTenderingId,
      SourceTaskId: sourceTaskId
    }
    const url = `${this.config.backendIwmUri}TenderingApi/TenderingAttachments/Default.CopyFileAttachmentsFromTask`;
    return this.http.post<Observable<null>>(url, body, { observe: 'response' })
      .pipe(map(response => response.status === 200),
        catchError(this.handleError(false)));
  }

  public copyFileAttachmentsFromWorksiteToTendering(targetTenderingId: string,
    sourceWorksiteId: string): Observable<null> {
    const body: any = {
      DestinationTenderingId: targetTenderingId,
      SourceWorksiteId: sourceWorksiteId
    }

    const url = `${this.config.backendIwmUri}TenderingApi/TenderingAttachments/Default.CopyFileAttachmentsFromWorksite`;
    return this.http.post<Observable<null>>(url, body, { observe: 'response' })
      .pipe(map(response => response.status === 200),
        catchError(this.handleError(false)));
  }


  public copyUnitsFromTask(targetTenderingId: string,
    sourceTaskId: string): Observable<null> {
    const body: any = {
      TenderingId: targetTenderingId,
      TaskId: sourceTaskId
    }

    const url = `${this.config.backendIwmUri}TenderingApi/TenderingUnits/Default.CopyUnitsFromTask`;
    return this.http.post<Observable<null>>(url, body, { observe: 'response' })
      .pipe(map(response => response.status === 204),
        catchError(this.handleError(false)));
  }


  public copyUnitsFromWorksite(targetTenderingId: string,
    sourceWorksiteId: string): Observable<null> {
    const body: any = {
      TenderingId: targetTenderingId,
      WorksiteId: sourceWorksiteId
    }

    const url = `${this.config.backendIwmUri}TenderingApi/TenderingUnits/Default.CopyUnitsFromWorksite`;
    return this.http.post<Observable<null>>(url, body, { observe: 'response' })
      .pipe(map(response => response.status === 204),
        catchError(this.handleError(false)));
  }

  /**
   * Handling error statuscodes 
   */
  private handleError(errorResponse: any) {
    return (err: any) => {
      if (err instanceof HttpErrorResponse) {
        return of(errorResponse);
      }
      else {
        return throwError(() => err);
      }
    }
  }
}

